import { cloneDeep } from 'lodash-es'

export const state = () => ({
  info: {},
  pageList: [],
  storeGoods: [],
  pwaVisible: false,
  couponDialogVisible: false,
  isStandAloneMode: false,
  pwaDrawerVisible: false,
  pwaPrompt: null,
  tutorialEnable: false,
  projectLangList: [],
  menuManageSelected: [],
  missionCenterVisible: false,
  pointTipVisible: false,
  missionCompleted: false,
  cyclePackageVisible: false,
  orderModal: {
    visible: false,
    order: null,
    payUrl: null,
    monthCardData: null,
    device: null
  },
  globalVars: {},
  nextIsShowCustomerService: false,
  isChange: false,
  activity: {
    signIn: {
      sign_in_list: [],
      consecutive_gift_list: []
    },
    addUp: {
      virtual_currency_icon: '',
      add_credit_type: '',
      country_currency: '',
      virtual_currency_num: '',
      activity_stop_time: '',
      activity_level_hit_list: [],
      totalNumber: 0
    }
  },
  shopGood: null,
  awaitGoods: null,
  awaitNav: null,
  currentVisibleDialogId: null,
  currentPageName: ''
})

export const mutations = {
  SET_ACTIVITY_DATA(state, { key, data }) {
    state.activity[key] = cloneDeep(data)
  },
  SET_CYCLE_PACKAGE_VISIBLE(state, data) {
    state.cyclePackageVisible = data
  },
  SET_AWAIT_NAV(state, data) {
    state.awaitNav = data
  },
  SET_IS_STAND_ALONE_MODE(state, data) {
    state.isStandAloneMode = data
  },
  SET_PROJECT_LANG_LIST(state, data) {
    state.projectLangList = data
  },
  SET_POINT_TIP_VISIBLE(state, data) {
    state.pointTipVisible = data
  },
  NEXT_IS_SHOW_CUSTOMER_SERVICE(state, data) {
    state.nextIsShowCustomerService = data
  },
  SET_TUTORIAL_ENABLE(state, data) {
    state.tutorialEnable = data
  },
  SET_INFO(state, info) {
    state.info = info
  },
  SET_COUPON_DIALOG(state, data) {
    state.couponDialogVisible = data
  },
  SET_PWA_VISIBLE(state, visible) {
    state.pwaVisible = visible
  },
  SET_PAGE_LIST(state, data) {
    state.pageList = data
  },
  SET_MENU_MANAGE_SELECTED(state, { menuManageId, menuId, modelIds }) {
    const current = state.menuManageSelected.findIndex(item => item.menuManageId === menuManageId)
    if (current !== -1) {
      state.menuManageSelected[current].menuId = menuId
      state.menuManageSelected[current].modelIds = modelIds
    } else {
      state.menuManageSelected.push({ menuManageId, menuId, modelIds })
    }
  },
  SET_PWA_DRAWER_VISIBLE(state, data) {
    state.pwaDrawerVisible = data
  },
  SET_PWA_PROMPT(state, data) {
    state.pwaPrompt = data
  },
  SET_GLOBAL_VARS(state, data) {
    state.globalVars = data
  },
  SET_STORE_GOODS(state, data) {
    state.storeGoods = data
  },
  SET_SHOP_GOOD(state, data) {
    state.shopGood = data
  },
  SET_AWAIT_GOODS(state, data) {
    state.awaitGoods = data
  },
  SET_IS_CHANGE(state, data) {
    state.isChange = data
  },
  SET_MISSION_CENTER_VISIBLE(state, data) {
    state.missionCenterVisible = data
  },
  SET_MISSION_COMPLETED(state, data) {
    state.missionCompleted = data
  },
  SHOW_ORDER_MODAL(state, { code, payUrl, monthCardData, device = null }) {
    state.orderModal.visible = true
    state.orderModal.order = code
    state.orderModal.payUrl = payUrl
    state.orderModal.monthCardData = monthCardData
    state.orderModal.device = device
  },
  CLOSE_ORDER_MODAL(state) {
    state.orderModal.visible = false
    state.orderModal.order = null
    state.orderModal.payUrl = null
    state.orderModal.monthCardData = null
    state.orderModal.device = null
  },
  SET_CURRENT_VISIBLE_DIALOG_ID(state, data) {
    state.currentVisibleDialogId = data
  },
  SET_CURRENT_PAGE_NAME(state, data) {
    state.currentPageName = data
  }
}
